import React from 'react';
import { ErrorResponse } from '@apollo/client/link/error';
import { GraphQLError } from 'graphql';

import { CodeBlock } from '@trqk/components';

interface Props {
    errorResponse: ErrorResponse;
}

const width = 810;

export const ApolloErrorCard = ({ errorResponse }: Props): JSX.Element => {
    const { graphQLErrors, networkError, response, operation } = errorResponse;

    return (
        <div className="m-4 rounded-lg">
            <h3>Apollo Client Error</h3>
            <div
                className="overflow-auto"
                style={{
                    height: 500,
                    width,
                }}
            >
                {graphQLErrors && (
                    <>
                        <div className="text-quinary-500 my-2 font-bold text-lg">
                            GraphQL Errors
                        </div>
                        {graphQLErrors.map(
                            (
                                error: GraphQLError,
                                index: number,
                            ): JSX.Element => (
                                <CodeBlock
                                    key={error.path?.join('') ?? index}
                                    title={`Error ${index + 1}`}
                                    code={error}
                                />
                            ),
                        )}
                        <hr className="my-4" />
                    </>
                )}
                {networkError && (
                    <>
                        <CodeBlock title="Network error" code={networkError} />
                        <hr className="my-4" />
                    </>
                )}
                {response && (
                    <>
                        <CodeBlock title="Server response" code={response} />
                        <hr className="my-4" />
                    </>
                )}
                {operation && (
                    <>
                        <CodeBlock
                            title="Operation that failed"
                            code={operation}
                        />
                        <hr className="my-4" />
                    </>
                )}
            </div>
        </div>
    );
};
